import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRole } from "src/models/Maintenance/Role.models";

interface RoleState {
  roles: IRole[];
  roleToEdit: IRole | null;
}

const initialState: RoleState = {
  roles: [],
  roleToEdit: null,
};

const roleSlice = createSlice({
  name: "Role",
  initialState,
  reducers: {
    setRoleList: (state, action: PayloadAction<IRole[]>) => {
      state.roles = action.payload;
    },
    concatListRole: (state: RoleState, action: PayloadAction<IRole[]>) => {
      state.roles = [...state.roles.concat(action.payload)];
    },
    setRoleToEdit: (state, action: PayloadAction<IRole | null>) => {
      state.roleToEdit = action.payload;
    },
    addRole: (state, action: PayloadAction<IRole>) => {
      state.roles.push(action.payload);
    },
    updateRole: (state, action: PayloadAction<IRole>) => {
      let itemIndex = state.roles.findIndex(
        item => item.roleId === action.payload.roleId
      );
      if (itemIndex !== -1) state.roles[itemIndex] = action.payload;
    },
    deleteRole: (state, action: PayloadAction<number>) => {
      const newArray = state.roles.filter(
        item => item.roleId !== action.payload
      );
      state.roles = newArray;
    },
  },
});

export const {
  setRoleList,
  concatListRole,
  setRoleToEdit,
  addRole,
  updateRole,
  deleteRole,
} = roleSlice.actions;

export default roleSlice.reducer;
